
<template>
  <div class="home">
    <!-- pc端 -->
    <div class="pc_header">
      <div class="pc_wrapper">
        <img src="../../assets/img/app_icon.png" alt="" />
        <p>大学答案君</p>
      </div>
    </div>
    <div class="pc_main">
      <transition        
        name="fade"
        mode="out-in"
      >
        <div class="pc_main_title" v-if="textChangeStatus" :key="1">
          <p>{{ slideOne.title }}</p>
          <p>{{ slideOne.dec }}</p>
        </div>
        <div class="pc_main_title" v-else :key="2">
          <p>{{ slideTwo.title }}</p>
          <p>{{ slideTwo.dec }}</p>
        </div>
      </transition>
      <div class="qrcode">
        <img src="../../assets/img/qrCode.png" alt="" />
      </div>
      <div class="comming">
        <div class="android" style="cursor:pointer;" @click="downAndroid">
          <img src="../../assets/img/android.png" alt="" />
          <p>Android下载</p>
        </div>
        <div class="ios" style="cursor:pointer;" @click="downIos">
          <img src="../../assets/img/ios.png" alt="" />
          <p>App Store下载</p>
        </div>
      </div>
    </div>
    <div class="pc_tips">
      <p>
        黔ICP备20000285号<br />
        ©2020 贵州筑梦空间信息科技有限公司 大学答案君
      </p>
    </div>
    <!-- 移动端轮播 -->
    <swiper :options="swiperOption" ref="mySwiper" class="phoneSwp">
      <swiper-slide
        v-for="(item, index) in phoneSwiper"
        :key="index"
        :style="{ 'background-color': item.bgc }"
      >
        <div class="swp_header">
          <p>{{ item.title }}</p>
          <p>{{ item.dec }}</p>
        </div>
        <div class="bannerImg">
          <img :src="item.file" alt="" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination " slot="pagination"></div>
      <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
      ></div>
    </swiper>
    <!-- pc端轮播 -->
    <swiper :options="swiperOption" ref="mySwiper" class="pcSwp">
      <swiper-slide
        v-for="(item, index) in pcSwiper"
        :key="index"
        :style="{ 'background-color': item.bgc }"
      >
        <div class="pc_banner">
          <img :src="item.file" alt="" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination " slot="pagination"></div>
      <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
      ></div>
    </swiper>
    <div class="phone_bot">
      <div class="android" style="cursor:pointer;" @click="downAndroid">
        <img src="../../assets/img/phone_android.png" alt="" />
        <p>Android下载</p>
      </div>
      <div class="ios" style="cursor:pointer;" @click="downIos">
        <img src="../../assets/img/phone_ios.png" alt="" />
        <p >App Store下载</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    const that = this;
    return {
      textChangeStatus: true,
      slideOne: {
        title: "大学答案君",
        dec: "大学课后教辅就用大学答案君"
      },
      slideTwo: {
        title: "网课答案",
        dec: "这里可以轻易搜到你的网课答案"
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          slideChangeTransitionStart: function() {
            if (this.activeIndex % 2 === 0 || this.activeIndex === 0) {
              that.textChangeStatus = false;
            } else {
              that.textChangeStatus = true;
            }
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true,
        initialSlide :2
      },
      screenWidth: "",
      phoneSwiper: [
        {
          bgc: "#01A8F7",
          file: require("../../assets/img/app.png"),
          title: "大学答案君",
          dec: "大学课后教辅就用大学答案君"
        },
        {
          bgc: "#0175F7",
          file: require("../../assets/img/phone_daxuedaanjun.png"),
          title: "大学答案君",
          dec: "大学课后教辅就用大学答案君"
        },
        {
          bgc: "#5A61DD",
          file: require("../../assets/img/phone_wangkedaan.png"),
          title: "网课答案",
          dec: "这里可以轻易搜到你的网课答案"
        },
        {
          bgc: "#33CFEB",
          file: require("../../assets/img/phone_smallprogram.png"),
          title: "大学答案君",
          dec: "扫码进入小程序"
        }
      ],
      pcSwiper: [
        {
          bgc: "#01A8F7",
          file: require("../../assets/img/daxuedaanjun.png")
        },
        {
          bgc: "#5A61DD",
          file: require("../../assets/img/wangkedaan.png")
        }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods:{
    downAndroid(){
      window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.dream.daanjun"
    },
    downIos(){
      window.location.href = "https://apps.apple.com/us/app/大学答案君/id1454103532?l=zh&ls=1"
    }
  },
  created() {},
  watch: {
    screenWidth(val) {
      console.log(val);
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    this.swiper.slideTo(3, 1000, false);
  }
};
</script>

<style lang='scss' scoped>
@import "../../assets/css/animation.css";
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.home {
  height: 100%;
  position: relative;
  .phone_bot {
    display: none;
  }
  .pc_header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 9.63%;
    .pc_wrapper {
      position: absolute;
      left: 25.26%;
      top: 23.08%;
      display: flex;
      align-items: center;
      & > p {
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-left: 30px;
      }
    }
  }
  .pc_main {
    position: absolute;
    left: 1122px;
    top: 29.44%;
    z-index: 99;
    width: 336px;
    .pc_main_title {
      text-align: right;
      & > p:first-child {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 24px;
      }
      & > p:last-child {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
      }
    }
    .qrcode {
      position: absolute;
      right: 160px;
      top: 161px;
      width: 101px;
      height: 102px;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .comming {
      width: 130px;
      position: absolute;
      right: -5px;
      top: 183px;
      & > div {
        width: 100%;
        height: 32px;
        background: rgba(81, 241, 209, 1);
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:nth-child(1) {
          margin-bottom: 15px;
        }
        img {
          width: 16px;
          height: 17px;
          margin-right: 5px;
        }
        p {
          font-size: 10px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(42, 42, 42, 1);
        }
      }
    }
  }
  .pc_tips {
    position: absolute;
    left: 25.26%;
    bottom: 4.44%;
    z-index: 999;
    p {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
      width: 286px;
    }
  }
  /deep/ .pcSwp {
    height: 100%;
    .swiper-wrapper {
      height: 100%;
      .swiper-slide {
        height: 100%;
        .pc_banner {
          position: absolute;
          top: 16.11%;
          left: 363px;
          width: 830px;
          height: 54.35%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .swiper-button-next {
      right: 121px;
    }
    .swiper-button-prev {
      left: 121px;
    }
    .swiper-pagination {
      top: 77.78%;
      & > span {
        width: 12px;
        height: 12px;
        background: rgba(255, 255, 255, 1);
      }
    }
  }
  /deep/ .phoneSwp {
    height: 100%;
    display: none;
  }
  @media screen and (max-width: 1446px) {
    & {
      width: 1446px;
    }
  }
  @media screen and (max-width: 768px) {
    & {
      width: auto;
    }
    .pc_header,
    .pc_main,
    .pcSwp,
    .pc_tips {
      display: none !important;
    }
    /deep/ .swiper-container {
      height: 100%;
      display: block;
      .swiper-wrapper {
        .swiper-slide {
          .swp_header {
            width: 100%;
            text-align: center;
            padding-top: 3.453333rem;
            & > p:first-child {
              font-size: 0.48rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(255, 255, 255, 1);
            }
            & > p:last-child {
              font-size: 0.32rem;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: rgba(255, 255, 255, 1);
              margin-top: 1.8%;
            }
          }
          .bannerImg {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 7.08rem;
            margin-top: -0.533333rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .swiper-pagination {
        top: 65%;
        & > span {
        background: rgba(255, 255, 255, 1);
      }
      }
      .swiper-button-white {
        top: 7.28rem;
        width: 0.76rem;
        height: 0.76rem;
      }
    }
    .phone_bot {
      position: absolute;
      top: 73.61%;
      z-index: 99;
      width: 12.773333rem;
      left: 50%;
      transform: translate(-50%);
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      & > div {
        display: flex;
        width: 6.4rem;
        height: 1.173333rem;
        border-radius: 1.173333rem;
        margin: 0 auto 4.76%;
        align-items: center;
        justify-content: center;
        img {
          width: 0.666667rem;
          height: 0.666667rem;
          // margin-left: 2.026667rem;
        }
        p {
          margin-left: 0.213333rem;
        }
        &:first-child {
          background: rgba(81, 241, 209, 1);
        }
        &:last-child {
          background: rgba(255, 255, 255, 1);
        }
        p {
          display: flex;
          align-items: center;
          font-size: 0.433333rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(42, 42, 42, 1);
        }
      }
    }
  }
}
</style>